<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="addNewDataSidebar = false"
      :title="titleSideBar">
      <formCadastro slot="form" @cancel="addNewDataSidebar = false" @concluido="concluido" :sideBar="true"
        :dados="dadosSideBar" :contadorRender="contadorRender"></formCadastro>
    </add-new-data-sidebar>

    <vs-table noDataText="Nenhum Usuário Encontrado" class="tablePrincipal" ref="table" multiple v-model="selected"
      :max-items="itemsPerPage" :data="itens">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item :disabled="!$can('usuarios', 'edit')" @click="inativar">
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item :disabled="!$can('usuarios', 'edit')" @click="reativar">
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="exportar">
                <span>Exportar</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!------------ START ADD NOVO USUÁRIO ------------>
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="openSideBar({})">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Adicionar novo Usuário</span>
          </div>
        </div>
        <!------------ END ADD NOVO USUÁRIO ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                itens.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : itens.length
              }}
              de {{ qtdTotal }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="nome" v-if="!decoded.idEmpresa">Empresa</vs-th>
        <vs-th sort-key="nome">Nome</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="tipo">Tipo</vs-th>
        <vs-th sort-key="tipo">Saldo</vs-th>
        <vs-th sort-key="tipo">Valor Pix Pagos</vs-th>
        <vs-th sort-key="deletedAt">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td v-if="!decoded.idEmpresa">
              <p class="product-category">{{ tr.nomeEmpresa }}</p>
            </vs-td>

            <vs-td>
              <vs-list-item :title="tr.nome" :subtitle="tr.Setor">
                <template slot="avatar">
                  <vs-avatar />
                </template>
              </vs-list-item>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.email }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.perfil }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.saldo }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.valorPix }}</p>
            </vs-td>

            <vs-td>
              <vs-chip :color="getStatusColor(tr.deletedAt)" class="product-order-status">{{
                getStatusString(tr.deletedAt)
                }}</vs-chip>
            </vs-td>
            <vs-td>
              <div class="vx-row">
                <div class="vx-col">
                  <router-link :to="`detalheUsuario/${tr.idUsuario}`">
                    <vs-button v-tooltip="'Detalhes do Usuário'" radius color="dark" type="gradient" icon-pack="feather"
                      icon="icon-search" class="d-inline"></vs-button></router-link>
                </div>
                <div class="vx-col">
                  <vs-button v-if="$can('usuarios', 'edit')" v-tooltip="'Editar Usuário'" radius color="success"
                    type="gradient" icon-pack="feather" icon="icon-edit" class="d-inline"
                    @click="openSideBar(tr)"></vs-button>
                </div>
                <div class="vx-col">
                  <vs-button radius v-tooltip="'Resetar Senha'" color="warning" type="gradient" icon-pack="feather"
                    icon="icon-lock" class="d-inline" @click="resetSenha(tr.idUsuario)"></vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-card>
      <vs-pagination :max="screenWidth < 650 ? 5 : 9" v-if="qtdPaginas" :total="qtdPaginas"
        v-model="paginaAtual"></vs-pagination></vs-card>
    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO USUÁRIO ------------>
    <ModalInfo :modalSelecionado="modalSelecionado" :popupActive="popupActive" :title="`Dados do ${entidade}`"
      @close="popupActive = false"></ModalInfo>

    <!------------ END INFORMAÇÕES DO USUÁRIO ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from "./../../Includes/SideBar";
import service from "./../../../services";
import downloadexcel from "vue-json-excel";
import ModalInfo from "./../../../components/ModalInfo";
import formCadastro from "./FormUsuario.vue";
import jwt from "jsonwebtoken";
import * as XLSX from "xlsx";
export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    formCadastro,
    ModalInfo,
  },
  watch: {
    realizaFiltro: function (newValue) {
      if (newValue == true) {
        this.buscaDados();
        this.$emit("filtroOk", true);
      }
    },
    paginaAtual: function () {
      console.log(this.paginaAtual);
      this.buscaDados();
    },
    itemsPerPage: function () {
      console.log(this.itemsPerPage);
      this.buscaDados();
    },
  },
  props: ["filtro", "realizaFiltro", "subjectPermission"],
  data() {
    return {
      decoded: service.getDecoded(),
      idEmpresa: null,
      isAdmin: false,
      dadosSideBar: {},
      controllerGeral: "Usuario",
      formSideBar: "usuario",
      entidade: "Usuário",
      showCancelarEncomenda: false,
      titleSideBar: "Adicionar Usuario",
      popupActive: false,
      modalSenha: false,
      modalSelecionado: [],
      userAlteracao: null,
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 10,
      paginaAtual: 1,
      qtdPaginas: 0,
      isMounted: false,
      addNewDataSidebar: false,
      contadorRender: 0,
      senha: null,
      screenWidth: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    // resetSenha(idUsuario) {
    //   if (!idUsuario) {
    //     this.$vs.notify({
    //       position: "top-center",
    //       title: "Atenção",
    //       text: "Usuário inválido para reset de senha",
    //       color: "warning",
    //     });
    //     return;
    //   }

    //   this.$vs.loading();

    //   service
    //     .put(this.controllerGeral, "TrocarSenha", {
    //       idUsuario: idUsuario,
    //     })
    //     .then(() => {
    //       this.showCancelarEncomenda = false;
    //       this.$vs.notify({
    //         position: "top-center",
    //         title: "Sucesso",
    //         text: "Senha redefinida para: 123456",
    //         color: "success",
    //       });
    //     })
    //     .catch((e) => {
    //       this.$vs.notify({
    //         position: "top-center",
    //         title: "Erro",
    //         text: (e && e.message) || "Erro ao redefinir a senha",
    //         color: "danger",
    //       });
    //     })
    //     .finally(() => {
    //       this.$vs.loading.close();
    //     });
    // },
    resetSenha(idUsuario) {
      if (!idUsuario) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Usuário inválido para reset de senha",
          color: "warning",
        });
        return;
      }
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Confirmação",
        text: "Você tem certeza que deseja resetar a senha desse usuário?",
        acceptText: "Resetar",
        cancelText: "Cancelar",
        accept: () => {
          this.$vs.loading();
          service
            .put(this.controllerGeral, "TrocarSenha", {
              idUsuario: idUsuario,
            })
            .then(() => {
              this.showCancelarEncomenda = false;
              this.$vs.notify({
                position: "top-center",
                title: "Sucesso",
                text: "Senha redefinida para: 123456",
                color: "success",
              });
            })
            .catch((e) => {
              this.$vs.notify({
                position: "top-center",
                title: "Erro",
                text: (e && e.message) || "Erro ao redefinir a senha",
                color: "danger",
              });
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        },
      });
    },
    verificaAdmin() {
      const token = localStorage.getItem("user-token");
      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == "Super User") this.isAdmin = true;
      }
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    inativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idUsuario);
        });
        service
          .post(this.controllerGeral, "Inativar", { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro inativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    reativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idUsuario);
        });
        service
          .post(this.controllerGeral, "Reativar", { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro reativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    buscaDados() {
      this.filtred = true;
      this.selected = [];
      this.$vs.loading();
      var objSend = {};
      if (this.filtro) {
        objSend = { ...this.filtro };
      }

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;

      service
        .post("Usuario", "listarUsuariosFiltro", objSend)
        .then((res) => {
          this.itens = [];
          console.log(res.data);
          this.exibir = true;
          this.itens = [];
          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

          if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);

          if (this.qtdTotal > 0) {
            res.data.usuarios.forEach((element) => {
              this.itens.push(element);
            });
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Nenhum Registro Encontrado",
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    openSideBar(dados) {
      dados.idUsuario == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
      this.contadorRender = this.contadorRender + 1;
    },
    openModalSenha(cod) {
      this.userAlteracao = {};
      this.modalSenha = true;
      this.userAlteracao = this.itens.find((x) => x.idUsuario == cod);
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idUsuario == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != "createdAt" &&
          element != "updatedAt" &&
          element != "deletedAt" &&
          element.indexOf("id") != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.addNewDataSidebar = false;
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return "success";
      return "danger";
    },
    getStatusString(data) {
      if (data == null) return "Ativo";
      return "Inativo";
    },
    exportar() {
      this.$vs.loading();
      this.filtred = true;
      this.selected = [];
      this.$vs.loading();
      var objSend = {};
      if (this.filtro) {
        objSend = { ...this.filtro };
      }

      service
        .post("Usuario", "listarUsuariosFiltro", objSend)
        .then((res) => {
          const ws = XLSX.utils.json_to_sheet(res.data.usuarios);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
          XLSX.writeFile(wb, "Usuario.xlsx");
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Nenhum Registro Encontrado",
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
    this.verificaAdmin();
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }

  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }

  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }

  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }

  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }

  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
